import { IPlanningWizardState } from './models/state'

export const initialState: IPlanningWizardState = {
  isVisible: false,
  wizardSteps: [],
  isLoading: false,
  error: null,
  activeStepId: null,
  wasOpened: false,
  isSaveDisabled: true,
  isHideWizard: false,
}
